import React, { useState } from "react";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import { Box, Button, Modal, Typography, CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import { route } from "../../services/apiRoutes";
import {
  deleteBooking,
  setCheckFirstStepCompleted,
  setResetData,
  updateSaveForLater,
} from "../../pages/new-booking-form/new-booking-form.slice";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SnackbarAlert from "../snackbar-alert/SnackbarAlert";
import ConfirmationModal from "../confirmation-modal/ConfirmationModal";
import { ERROR_MESSAGE } from "../../config/constant";
import "./common-button.scss";
const CommonButton = ({
  handlePrevious,
  handleNext,
  isDisable,
  nextStep,
  innerSteps,
  showPrevBtn,
  applicantNo,
  saveAndPreview,
  saveDraftData,
  fromPage,
  saveDraftPath,
  saveDraftMethod,
  saveForLater = true,
  isSaveAsDraftDisabled = false,
  buttonLoading = false,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [openApplicantCountModal, setOpenApplicantCountModal] = useState(false);
  const dispatch = useDispatch();
  const { oppId } = useParams();
  const history = useHistory();
  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const {
    isLoading,
    showSaveAndPreview,
    applicantData,
  } = useSelector((state) => state?.newBookingForm);

  const handleSaveDraft = () => {
    let payload = {
      // ...applicantData,
      ...saveDraftData,
      // lastStep: activeStep,
      // isCompleted: false,
      // saveForLater: true,
    };

    dispatch(
      // updateReviewDetails({
      //   path: `${route.UPDATE_APPLICANT_DATA}/${oppId}`,
      //   payload: payload,
      // })
      updateSaveForLater({
        path: saveDraftPath ? saveDraftPath : `${route.UPDATE_APPLICANT_DATA}/${oppId}`,
        payload: payload,
        opportunityId: oppId,
        method: saveDraftMethod
      })
    )
      .unwrap()
      .then((res) => {
        if (res?.data) {
          if (fromPage === "professional" && applicantNo === 1) {
            dispatch(setCheckFirstStepCompleted(true));
          }
          setOpenModal(!openModal);
        }
      })
      .catch((error) => {
        // handle error here
      });
  };

  const handleClearApplicantData = () => {
    setOpenApplicantCountModal(!openApplicantCountModal);

    let payload = {
      opportunityId:oppId,
    };
    dispatch(deleteBooking(payload))
      .unwrap()
      .then((res) => {
        if (res?.statusCode === 200 || res?.statusCode === 201) {
          dispatch(setResetData());

          // For multi-unit booking, navigate back to group listing
          if (applicantData?.groupId) {
            history.push(`/group-listing/${applicantData.groupId}`);
        } else {
            window.location.href = `/booking-form/${oppId}`;
        }
        }
      })
      .catch((error) => {
        setSnackbarConfig({
          open: true,
          message: ERROR_MESSAGE,
          severity: "error",
        });
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarConfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: {
            xs: "100%", // Full width on mobile
            sm: "100%", // Slightly smaller width on tablets
            md: "100%", // Even smaller width on desktop
          },
          mt: {
            xs: "20px", // Margin top for mobile
            sm: "40px", // Margin top for tablets
            md: "60px", // Margin top for desktops
          },
          flexDirection: {
            xs: "column", // Stack vertically on mobile
            sm: "row", // Align horizontally on tablets and larger
          },
        }}
      >
        {saveForLater && ( <Button
          startIcon={<BookmarkBorderIcon />}
          type="button"
          sx={{
            width: {
              xs: "200px",
              sm: "200px",
              md: "200px",
              lg: "200px",
            },
            height: "48px",
            borderRadius: "8px",
            background: "#fff",
            color: "#1A407D",
            fontSize: "16px",
            fontWeight: "600",
            lineHeight: "24px",
            textTransform: "capitalize",
            border: "1px solid #D0D5DD",
            "&:hover": {
              backgroundColor: "#092552",
              color: "#fff",
            },
            mb: {
              xs: "24px",
              sm: "0px",
              md: "0px",
              lg: "0px",
            },
          }}
          onClick={() => {
            handleSaveDraft();
          }}
          disabled={isSaveAsDraftDisabled}
        >
          Save as Draft
        </Button>)}

        <Box
          className="mobileBtnPreview"
          sx={{
            display: "flex",
            width: {
              xs: "100%",
            },
            justifyContent: {
              xs: "row",
              sm: "flex-end",
              md: "flex-end",
              lg: "flex-end",
            },
            flexDirection: {
              xs: "row",
              sm: "row",
              md: "row",
              lg: "row",
            },
            gap: {
              xs: "16px",
              md: "8px",
              lg: 2,
            },
          }}
        >
          {/* applicantActiveStep === 2 */}
          {/* (applicantNo === 1 ||
            applicantNo === 2 ||
            applicantNo === 3 ||
            applicantNo === 4) && */}
          {
            showSaveAndPreview && (
              <div className="mobileSaveAndPreview">
                <Button
                  type="button"
                  // disabled={isDisable}
                  className='saveandpreview'
                  sx={{
                    width: {
                      xs: "200px",
                      sm: "220px",
                      md: "220px",
                      lg: "220px",
                    },
                    height: "48px",
                    borderRadius: "8px",
                    background: "#1A407D",
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    textTransform: "capitalize",
                    "&:hover": {
                      backgroundColor: "#092552",
                    },
                  }}
                  onClick={() => {
                    saveAndPreview();
                  }}
                >
                  Save and preview
                </Button>
              </div>
            )}
          {/* {showPrevBtn !== true && ( */}
          <div className="mobilePrevNext">
            <Button
              startIcon={
                <Box
                  sx={{
                    width: "24px",
                    height: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <NavigateNextIcon
                    sx={{
                      transform: "rotate(180deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </Box>
              }
              type="button"
              sx={{
                width: {
                  xs: "48%",
                  sm: "157px",
                  md: "157px",
                  lg: "157px",
                },
                marginTop: { xs: "0px", sm: "0px", md: "0px", lg: "0px" },
                marginBottom: { xs: "0px", sm: "0px", md: "0px", lg: "0px" },
                height: "48px",
                borderRadius: "8px",
                background: "#fff",
                color: "#1A407D",
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "24px",
                textTransform: "capitalize",
                border: "1px solid #D0D5DD",
                "&:hover": {
                  backgroundColor: "#092552",
                  color: "#fff",
                },
              }}
              onClick={() => {
                if (showPrevBtn) {
                  setOpenApplicantCountModal(!openApplicantCountModal);
                } else {
                  handlePrevious();
                }
              }}
            >
              Previous
            </Button>
            {/* )} */}
            <Button
              endIcon={
                <Box
                  sx={{
                    width: "24px",
                    height: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <NavigateNextIcon />
                </Box>
              }
              type="submit"
              disabled={isDisable}
              className={isDisable ? "disableCTA" : ""}
              sx={{
                width: {
                  xs: "48%",
                  sm: "157px",
                  md: "157px",
                  lg: "157px",
                },
                height: "48px",
                borderRadius: "8px",
                background: "#1A407D",
                color: "#fff",
                fontSize: "16px",
                fontWeight: "600",
                lineHeight: "24px",
                textTransform: "capitalize",
                "&:hover": {
                  backgroundColor: "#092552",
                },
              }}
              onClick={() => {
                handleNext("save");
              }}
            >
               {buttonLoading ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : (
                "Next"
              )}
            </Button>
          </div>
        </Box>
      </Box>
      {openModal ? (
          <Modal
            open={openModal}
            onClose={() => {
              setOpenModal(!openModal);
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="saveLaterModal"
            hideBackdrop={true}
            disableEscapeKeyDown={true}
          >
            <div className="modalContainer">
              <Box sx={{ border: "0" }}>
                <div
                  className="closeModal"
                  onClick={() => setOpenModal(!openModal)}
                >
                  <HighlightOffIcon />
                </div>
                <Typography
                  className="modalTitle"
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                >
                  Draft saved!
                </Typography>
                <div className="titleDear marginTop">
                  You can resume later using the link emailed to you.
                  <br />
                </div>
                {/* <a className="linkText" href="https://www.puravankara.com/">
                  Link
                </a> */}
              </Box>
            </div>
          </Modal>
      ) : null}
      <ConfirmationModal
        open={openApplicantCountModal}
        onClose={() => setOpenApplicantCountModal(false)}
        onConfirm={handleClearApplicantData}
        title="Do you want to change the booking type?"
        message="Going back will delete all entered information. You'll need to re-enter your details."
        confirmText="Yes"
        cancelText="No"
        disableBackdropClick={true}
      />
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};

export default CommonButton;
